import { render, staticRenderFns } from "./ListPerson.vue?vue&type=template&id=3d949730&scoped=true"
import script from "./ListPerson.vue?vue&type=script&lang=js"
export * from "./ListPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d949730",
  null
  
)

export default component.exports